(function () {
    angular.module('PWAPoCApp').controller('WeightApiSensorModalController', weightApiSensorModalController);

    weightApiSensorModalController.$inject = [
        '$rootScope',
        '$scope',
        '$windowInstance',
        'routeStop',
        'dataButton',
        'botekService',
        'pollingService',
        'commonUtil',
        'routeStopsNearby',];

    function weightApiSensorModalController(
        $rootScope,
        $scope,
        $windowInstance,
        routeStop,
        dataButton,
        botekService,
        pollingService,
        commonUtil,
        routeStopsNearby) {
       
        $scope.isManualMode = false;
        $scope.numbers = '';
        $scope.weightValues = [];

        $scope.isRfid = $rootScope.botekSettings.enableBotekHyperionByRFIDGPS || $rootScope.botekSettings.enableBotekHyperionByRFID;
        $scope.files = getBotekFileValues($rootScope.botekFiles);
        $scope.getContainerName = getContainerName;

        const botekWaitingMsg = "Venter på vektdata";
       
        initController();

        function initController() {
            $scope.isManualMode = false;
            $rootScope.$broadcast('showBusyIndicator', botekWaitingMsg);
            const weightValuesPolling = pollingService.startPolling(200, () => {
                if ($rootScope.botekWeightValues?.length) {
                    $rootScope.$broadcast('hideBusyIndicator');
                    pollingService.stopPolling(weightValuesPolling);
                }
            });
        }

        $scope.setValue = function() {
            addWeightToUnits();
            botekService.stopPolling();
            if (!$scope.isManualMode) {
                botekService.deleteAllFilesFromServer();
            }
            $windowInstance.close({ routeStop: routeStop, weight: $rootScope.botekSumWeight });
        };

        
        $scope.setManual = function () {
            if (!Number($rootScope.botekSumWeight)) {
                $rootScope.$broadcast('hideBusyIndicator');
                initManual();
                $scope.isManualMode = true;
            }
        }

        $scope.OkButtonEnabled = function() {
            return Number($rootScope.botekSumWeight);
        }
        $scope.ManualEnabled = ()=> {
            return !Number($rootScope.botekSumWeight);
        }
       
        //manual input weight
        $scope.numbers = '';
        $scope.addComma = addComma;
        $scope.back = back;
        $scope.save = save;
        $scope.saveEnabled = () => Number($rootScope.botekSumWeight);

        function initManual() {
            if (dataButton.value) {
                $scope.numbers = dataButton.value.toString();
            }
        }

        function addComma() {
            if ($scope.numbers.indexOf(',') === -1) {
                $scope.numbers += ',';
            }
        }

        function back() {
            $scope.isManualMode = false;
            $rootScope.$broadcast('showBusyIndicator', botekWaitingMsg);
        }

        function save() {
            $rootScope.botekSumWeight = commonUtil.correctDataButtonValueFloatFormat($scope.numbers);
            $scope.setValue();
        }

        function getContainerName(rfid) {
            if (!routeStopsNearby || !Array.isArray(routeStopsNearby)) {
                return "";
            }

            for (const rs of routeStopsNearby) {
                if (rs.units && Array.isArray(rs.units)) {
                    const unit = rs.units.find(
                        (unit) => unit.labelId?.toString() === rfid.toString()
                    );
                    if (unit) {
                        return unit.name;
                    }
                }
            }

            return "";
        }

        function getBotekFileValues(files){
            if (!files) return [];
            const botekFileValues = files.map(file => {
                const objKeys = Object.keys(file);
                const fileName = objKeys[0];
                const weight = file[fileName].weight;
                const id = file[fileName].id;
                return {weight, id};
            });

            return botekFileValues || [];
        }

        function addWeightToUnits() {
            $scope.files.forEach(file => {
                routeStopsNearby.forEach(nearbyRouteStop => {
                    nearbyRouteStop.units.forEach(unit => {
                        if (unit.labelId.toString() === file.id.toString()) {
                            const formattedWeightValue = Number(commonUtil.correctDataButtonValueFloatFormat(file.weight).split(',').join('.')); //"0,0" -> "0" -> 0
                            unit.unitWeight = formattedWeightValue.toString();
                        }
                    });
                })
            })
        }
    }
})();
